"use strict";
export default [
  {
    id: "0",
    //头部切换团队
    config: {
      category: "\u5207\u6362\u56E2\u961F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "1",
    //头部鲸豆充值
    config: {
      category: "\u9CB8\u8C46\u5145\u503C",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "2",
    //头部新人指导
    config: {
      category: "\u65B0\u4EBA\u6307\u5BFC",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "3",
    //头部邀请好礼
    config: {
      category: "\u9080\u8BF7\u597D\u793C",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "4",
    //切换店铺模式
    config: {
      category: "\u5207\u6362\u5E97\u94FA\u6A21\u5F0F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "5",
    //VD模式分组管理展开
    config: {
      category: "VD\u6A21\u5F0F\u5206\u7EC4\u7BA1\u7406\u5C55\u5F00",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "6",
    //VD模式分组管理编辑
    config: {
      category: "VD\u6A21\u5F0F\u5206\u7EC4\u7BA1\u7406\u7F16\u8F91",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "7",
    //左侧菜单栏收起
    config: {
      category: "\u5DE6\u4FA7\u83DC\u5355\u680F\u6536\u8D77",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "8",
    //购买VD
    config: {
      category: "\u8D2D\u4E70VD",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "9",
    //VD导出
    config: {
      category: "VD\u5BFC\u51FA",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "10",
    //VD筛选
    config: {
      category: "VD\u7B5B\u9009",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "11",
    //VD切换块模式
    config: {
      category: "VD\u5207\u6362\u5757\u6A21\u5F0F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "12",
    //VD切换列表模式
    config: {
      category: "VD\u5207\u6362\u5217\u8868\u6A21\u5F0F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "13",
    //店铺模式分组管理展开
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u5206\u7EC4\u7BA1\u7406\u5C55\u5F00",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "14",
    //店铺模式分组管理编辑
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u5206\u7EC4\u7BA1\u7406\u7F16\u8F91",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "15",
    //创建店铺
    config: {
      category: "\u521B\u5EFA\u5E97\u94FA",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "16",
    //导入店铺
    config: {
      category: "\u5BFC\u5165\u5E97\u94FA",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "17",
    //店铺导出
    config: {
      category: "\u5E97\u94FA\u5BFC\u51FA",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "18",
    //店铺筛选
    config: {
      category: "\u5E97\u94FA\u7B5B\u9009",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "19",
    //VD模式续费
    config: {
      category: "VD\u6A21\u5F0F\u7EED\u8D39",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "20",
    //VD模式修改VD
    config: {
      category: "VD\u6A21\u5F0F\u4FEE\u6539VD",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "21",
    //VD模式开启自动续费
    config: {
      category: "VD\u6A21\u5F0F\u5F00\u542F\u81EA\u52A8\u7EED\u8D39",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "22",
    //VD模式关闭自动续费
    config: {
      category: "VD\u6A21\u5F0F\u5173\u95ED\u81EA\u52A8\u7EED\u8D39",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "23",
    //VD模式分组
    config: {
      category: "VD\u6A21\u5F0F\u5206\u7EC4",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "24",
    //VD模式分配管理员
    config: {
      category: "VD\u6A21\u5F0F\u5206\u914D\u7BA1\u7406\u5458",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "25",
    //VD模式取消管理员
    config: {
      category: "VD\u6A21\u5F0F\u53D6\u6D88\u7BA1\u7406\u5458",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "26",
    //VD模式释放VD
    config: {
      category: "VD\u6A21\u5F0F\u91CA\u653EVD",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "27",
    //店铺模式分组
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u5206\u7EC4",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "28",
    //店铺模式批量修改店铺
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u6279\u91CF\u4FEE\u6539\u5E97\u94FA",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "29",
    //店铺模式批量绑定IP
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u6279\u91CF\u7ED1\u5B9AIP",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "30",
    //店铺模式批量授权
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u6279\u91CF\u6388\u6743",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "31",
    //店铺模式批量取消授权
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u6279\u91CF\u53D6\u6D88\u6388\u6743",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "32",
    //店铺模式批量删除店铺
    config: {
      category: "\u5E97\u94FA\u6A21\u5F0F\u6279\u91CF\u5220\u9664\u5E97\u94FA",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "33",
    //自定义显示列
    config: {
      category: "\u81EA\u5B9A\u4E49\u663E\u793A\u5217",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "34",
    //我的团队添加成员
    config: {
      category: "\u6211\u7684\u56E2\u961F\u6DFB\u52A0\u6210\u5458",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "35",
    //我的团队筛选
    config: {
      category: "\u6211\u7684\u56E2\u961F\u7B5B\u9009",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "36",
    //我的团队自定义显示列
    config: {
      category: "\u6211\u7684\u56E2\u961F\u81EA\u5B9A\u4E49\u663E\u793A\u5217",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "37",
    //团队设置允许加入
    config: {
      category: "\u56E2\u961F\u8BBE\u7F6E\u5141\u8BB8\u52A0\u5165",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "38",
    //团队设置邀请审核
    config: {
      category: "\u56E2\u961F\u8BBE\u7F6E\u9080\u8BF7\u5BA1\u6838",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "39",
    //团队设置成员定期更新密码
    config: {
      category: "\u56E2\u961F\u8BBE\u7F6E\u6210\u5458\u5B9A\u671F\u66F4\u65B0\u5BC6\u7801",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "40",
    //团队设置切换团队验证
    config: {
      category: "\u56E2\u961F\u8BBE\u7F6E\u5207\u6362\u56E2\u961F\u9A8C\u8BC1",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "41",
    //部门管理添加子部门
    config: {
      category: "\u90E8\u95E8\u7BA1\u7406\u6DFB\u52A0\u5B50\u90E8\u95E8",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "42",
    //访问控制白名单模式
    config: {
      category: "\u8BBF\u95EE\u63A7\u5236\u767D\u540D\u5355\u6A21\u5F0F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "43",
    //访问控制黑名单模式
    config: {
      category: "\u8BBF\u95EE\u63A7\u5236\u9ED1\u540D\u5355\u6A21\u5F0F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "44",
    //访问控制新建规则
    config: {
      category: "\u8BBF\u95EE\u63A7\u5236\u65B0\u5EFA\u89C4\u5219",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "45",
    //主账号安全验证PIN验证
    config: {
      category: "\u4E3B\u8D26\u53F7\u5B89\u5168\u9A8C\u8BC1PIN\u9A8C\u8BC1",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "46",
    //访问日志导出当前列表
    config: {
      category: "\u8BBF\u95EE\u65E5\u5FD7\u5BFC\u51FA\u5F53\u524D\u5217\u8868",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "47",
    //访问日志筛选
    config: {
      category: "\u8BBF\u95EE\u65E5\u5FD7\u7B5B\u9009",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "48",
    //店铺风控日志导出当前列表
    config: {
      category: "\u5E97\u94FA\u98CE\u63A7\u65E5\u5FD7\u5BFC\u51FA\u5F53\u524D\u5217\u8868",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "49",
    //店铺风控日志筛选
    config: {
      category: "\u5E97\u94FA\u98CE\u63A7\u65E5\u5FD7\u7B5B\u9009",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "50",
    //鲸豆明细导出当前列表
    config: {
      category: "\u9CB8\u8C46\u660E\u7EC6\u5BFC\u51FA\u5F53\u524D\u5217\u8868",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "51",
    //订单管理开票
    config: {
      category: "\u8BA2\u5355\u7BA1\u7406\u5F00\u7968",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "52",
    //订单管理取消未支付
    config: {
      category: "\u8BA2\u5355\u7BA1\u7406\u53D6\u6D88\u672A\u652F\u4ED8",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "53",
    //订单管理导出当前列表
    config: {
      category: "\u8BA2\u5355\u7BA1\u7406\u5BFC\u51FA\u5F53\u524D\u5217\u8868",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "54",
    //订单管理筛选
    config: {
      category: "\u8BA2\u5355\u7BA1\u7406\u7B5B\u9009",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  },
  {
    id: "55",
    //发票管理开票信息
    config: {
      category: "\u53D1\u7968\u7BA1\u7406\u5F00\u7968\u4FE1\u606F",
      action: "\u9ED8\u8BA4",
      name: "",
      value: ""
    }
  }
];
